// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media(min-width: 576px){.w-sm-50[data-v-5bbc1fa4]{width:50% !important}}", ""]);
// Exports
module.exports = exports;
